module.exports = __webpack_public_path__ + "img/shop.68912c39.svg";